import { makeAutoObservable } from "mobx";
import { BUSINESS, LANGUAGES } from "../utils/enums";

class AnalyticsStore {
  common = {
    name: "asiakaspalautelomakkeet",
    form_name: "anna palautetta",
    group: "self-service",
    business_group: "other",
    channel: "ha",
    language: "",
  };

  constructor() {
    makeAutoObservable(this);
  }

  setCustomerType = (customerType) => {
    this.common.channel = customerType === BUSINESS ? "ya" : "ha";
  };

  setLanguage = (lang) => {
    this.common.language = LANGUAGES[lang];
  };

  sendPhaseEvent(event) {
    const eventData = Object.assign({}, this.common, {
      phase_category: event.name,
      phase: event.description,
    });
    this.sendEvent("application_phase", eventData);
  }

  sendActionEvent(event) {
    const eventData = Object.assign({}, this.common, {
      action_group: event.name,
      action_name: event.description,
    });
    this.sendEvent("application_action", eventData);
  }

  sendEvent = (name, data) => {
    try {
      if (window._satellite) {
        window._satellite.track(name, data);
      }
    } catch (e) {}
  };
}

const analyticsStore = new AnalyticsStore();

export default analyticsStore;
